import {
  AdminErrorMessage,
  AdminHeader,
  AdminLoadingPanel,
  AdminLoginPanel,
  AdminShell,
  AdminTabs,
  JobsPanel,
  LibraryPanel,
  OverviewPanel,
  SettingsPanel,
  UsersPanel,
} from "./AdminPagePanels";
import { useAdminData } from "./useAdminData";

export function AdminPage() {
  const admin = useAdminData();

  if (!admin.authChecked) {
    return <AdminLoadingPanel />;
  }

  if (!admin.session) {
    return (
      <AdminLoginPanel
        error={admin.error}
        pending={admin.pending}
        onLogin={admin.login}
      />
    );
  }

  return (
    <AdminShell>
      <AdminHeader session={admin.session} onLogout={admin.logout} />
      <AdminTabs activeTab={admin.activeTab} onChange={admin.setActiveTab} />
      <AdminErrorMessage error={admin.error} />

      {admin.activeTab === "overview" && (
        <OverviewPanel
          dashboard={admin.dashboard}
          onSelectJob={(jobId) => {
            admin.setActiveTab("jobs");
            void admin.selectJob(jobId);
          }}
        />
      )}

      {admin.activeTab === "jobs" && (
        <JobsPanel
          jobPlaylistMembership={admin.jobPlaylistMembership}
          jobs={admin.jobs}
          jobStatus={admin.jobStatus}
          pending={admin.pending}
          pendingPlaylistKey={admin.pendingPlaylistKey}
          playlists={admin.playlists}
          search={admin.search}
          selectedJob={admin.selectedJob}
          selectedSong={admin.selectedSong}
          onAddToPlaylist={admin.addToPlaylist}
          onCancelJob={admin.cancelJob}
          onCreateJob={admin.createJob}
          onDeleteJob={admin.deleteJob}
          onSearchChange={admin.setSearch}
          onSearchSubmit={admin.refreshCurrentData}
          onSelectJob={admin.selectJob}
        />
      )}

      {admin.activeTab === "library" && (
        <LibraryPanel
          pendingPlaylistKey={admin.pendingPlaylistKey}
          playlists={admin.playlists}
          recentSongs={admin.recentSongs}
          onAddToPlaylist={admin.addToPlaylist}
          onDeleteSong={admin.deleteSong}
          onRemoveFromPlaylist={admin.removeFromPlaylist}
        />
      )}

      {admin.activeTab === "users" && <UsersPanel users={admin.users} />}

      {admin.activeTab === "settings" && (
        <SettingsPanel
          pending={admin.pending}
          settings={admin.settings}
          onSave={admin.saveSettings}
        />
      )}
    </AdminShell>
  );
}
